// extracted by mini-css-extract-plugin
export default {"dropdownItem":"ProfileDropdownItem_dropdownItem__LwDGn","dropdownItemWarning":"ProfileDropdownItem_dropdownItemWarning__DIppi"};